import PropTypes from 'prop-types';
var refType = PropTypes.oneOfType([PropTypes.func, PropTypes.object]);
export default refType;


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/utils/esm/refType.js
// module id = 7406
// module chunks = 2